





















import Vue from "vue";

// Vue Component
import DeviceFolderTree from "@/components/DeviceFolderTree.vue";

// Model
import { MoveFolderReqData, MoveFolderCommand } from "@/model/communication/device/MoveFolderCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FolderDeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";

export default Vue.extend({
    components: {
        DeviceFolderTree,
    },
    data() {
        return {
            cardLoading: false,
            selectedFolder: null,
        };
    },
    props: {
        folderToMove: FolderDeviceTreeNode,
    },
    computed: {
        selectedFolderModel: {
            get() {
                return [this.selectedFolder];
            },
            set(newVal: any) {
                this.selectedFolder = newVal[newVal.length - 1];
            },
        },

        canSave() {
            return this.selectedFolder;
        },
    },
    watch: {
        folderToMove: {
            handler() {
                this.selectedFolder = null;
            },
            deep: true,
        },
    },
    methods: {
        async onSaveButtonClick() {
            if (this.canSave) {
                try {
                    this.cardLoading = true;

                    let req = new MoveFolderReqData(this.folderToMove.id, this.selectedFolder);
                    let res = await new MoveFolderCommand(req).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) this.$emit("reload-device-tree", this.selectedFolder);
                    this.$emit("close");
                    this.cardLoading = false;
                } catch (error) {
                    console.error("Error executing MoveFolderCommand, message: ", error);
                    this.cardLoading = false;
                }
            }
        },
    },
});
